/**
 * StatusCargaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {StatusCarga} from '@/model/resource/StatusCarga'

/* TODO: review generated class */
@HttpExclude()
export class StatusCargaCollection extends PageCollection<StatusCarga> {
  constructor() {
    super(StatusCarga)
  }

  queryAsPage() {
    return this.listStatusCarga()
  }

  async listStatusCarga() {
    return await Request.get(`/admin/status-carga`, {params: this.params})
      .name('listStatusCarga')
      .as(this)
      .getResponse()
  }

  async listCsvStatusCarga() {
    return await Request.get(`/admin/status-carga/csv`, {params: this.params})
      .name('listCsvStatusCarga')
      .as(this)
      .getResponse()
  }
}
